export default __webpack_public_path__ + "static/sokolov-7e10f46b562f8c59a0eeac3eeb92b102.png";